import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';
import { I18nProvider } from './landing/i18n';
import { LandingLayout } from './landing/LandingLayout';
import LandingHome from './landing/LandingHome';
import LandingDemo from './landing/LandingDemo';
import LandingAbout from './landing/LandingAbout';
import LandingContact from './landing/LandingContact';
import LandingScenarios from './landing/LandingScenarios';
import LandingFormation from './landing/LandingFormation';
import LandingLegal from './landing/LandingLegal';
import LandingPrivacy from './landing/LandingPrivacy';
import { ScrollToTop } from './components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <I18nProvider>
          <Routes>
            <Route path="/" element={<LandingLayout basePath="" />}>
              <Route index element={<LandingHome />} />
              <Route path="demo" element={<LandingDemo />} />
              <Route path="about" element={<LandingAbout />} />
              <Route path="scenarios" element={<LandingScenarios />} />
              <Route path="formation" element={<LandingFormation />} />
              <Route path="legal" element={<LandingLegal />} />
              <Route path="privacy" element={<LandingPrivacy />} />
              <Route path="contact" element={<LandingContact />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </I18nProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
